import GLightbox from 'glightbox';

const galleries = document.querySelectorAll('.wp-block-gallery.has-nested-images');

Array.from(galleries).forEach((gallery, galleryIndex) => {
  // Remove br
  const breakLines = gallery.querySelectorAll('br');
  Array.from(breakLines).forEach((br) => br.remove());

  // Add attributes to links to fire lightbox
  const links = gallery.querySelectorAll('a');
  Array.from(links).forEach((link) => {
    link.setAttribute('data-gallery', `gallery${galleryIndex + 1}`)
    link.setAttribute('data-glightbox', '');
  });
  
  // Init lightbox
  const lightbox = GLightbox({
    selector: 'data-glightbox'
  });
})